import AuthStore from 'auth-store';
import axios from 'axios';
import { set } from 'lodash';
import history from 'setup/history';

const baseURL = process.env.REACT_APP_END_POINT;

const service = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/vnd.api+json',
    Accept: 'application/json',
  },
});

const interceptRequest = (config) => {
  const token = AuthStore.get('_token');
  return token
    ? set(config, 'headers.Authorization', `Bearer ${token}`)
    : config;
};

service.interceptors.request.use(interceptRequest);

const errorResponseIntercept = (error) => {
  const status = error?.response?.status;
  const isExpired = error?.response?.data?.error === 'token_expired';

  if (status === 401 && isExpired) {
    // do something for logout
    history.push('/logout');
  }

  return Promise.reject(error);
};

service.interceptors.response.use(
  (response) => response,
  errorResponseIntercept,
);

export default service;
